import {
  closeAddOnsStoreModal,
  closeNewWorkspaceModal,
  setDebugModal,
  setEditWorkspaceModal,
  setShowAddressModal,
  setShowImpersonationBanner,
  setShowMultiDeviceBlockModal,
  setShowOverdueInvoiceBanner,
  setShowOverdueInvoiceModal,
  setShowTopupModal,
  setShowTrialEndingModal,
  setShowUpgradeModal,
  setUserColorModal,
} from "src/js/stores/navigation/actions";

import { AddOnsStoreModal } from "react-migration/domains/nav/components/Modals/AddOnsStoreModal";
import { BillingAddressModal } from "react-migration/domains/nav/components/Modals/BillingAddressModal";
import { DebugModal } from "react-migration/domains/nav/components/Modals/DebugModal/DebugModal";
import { ENVIRONMENT } from "src/js/util/environment";
import { EditWorkspaceModal } from "react-migration/domains/workspaces/components/EditWorkspaceModal/EditWorkspaceModal";
import { IMPERSONATION_COOKIE } from "react-migration/domains/nav/util/cookies";
import { ImpersonationBanner } from "react-migration/domains/nav/components/Banners/ImpersonationBanner";
import { LicenseBlockModal } from "react-migration/domains/nav/components/Modals/LicenseBlockModal";
import { MultiDeviceBlockModal } from "react-migration/domains/nav/components/Modals/MultiDeviceBlockModal";
import { NewWorkspaceModal } from "react-migration/domains/workspaces/components/NewWorkspaceModal";
import { OverdueInvoiceBanner } from "react-migration/domains/nav/components/Banners/OverdueInvoiceBanner";
import { OverdueInvoiceModal } from "react-migration/domains/nav/components/Modals/OverdueInvoiceModal";
import { TopupModal } from "react-migration/domains/nav/components/Modals/TopupModal";
import { TrialEndingModal } from "react-migration/domains/nav/components/Modals/TrialEndingModal";
import { UpgradeModal } from "react-migration/domains/nav/components/Modals/UpgradeModal";
import { UserColorModal } from "react-migration/domains/nav/components/Modals/UserColorModal/UserColorModal";
import { navigationStore } from "src/js/stores/navigation/store";
import { showTrial } from "react-migration/domains/nav/util/trial";
import { updateMapSettings } from "src/js/stores/map/actions/updateMapSettings";
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import { useIsMobile } from "react-migration/lib/theme/hooks/useIsMobile";
import { useLocalStorage } from "usehooks-ts";
import { useSnapshot } from "valtio";
import { useWorkspacesLimit } from "react-migration/domains/workspaces/hooks/useWorkspacesLimit";
import { userStore } from "src/js/stores/user/store";

export const NavbarMessages = () => {
  const { user } = useSnapshot(userStore);
  const {
    showTopupModal,
    newWorkspaceModal,
    editWorkspaceModal,
    topupModalOptions,
    showUpgradeModal,
    showTrialEndingModal,
    showOverdueInvoiceModal,
    showMultiDeviceBlockModal,
    showImpersonationBanner,
    showOverdueInvoiceBanner,
    showDebugModal,
    showUserColorModal,
    showBillingAddressModal,
    billingAddressModalProps,
    addOnsStoreModalPath,
  } = useSnapshot(navigationStore);
  const { limitReached } = useWorkspacesLimit();

  const isMobile = useIsMobile();
  const [cookies] = useCookies([IMPERSONATION_COOKIE]);
  const [overdueInvoiceNextReminder, setOverdueInvoiceNextReminder] = useLocalStorage(
    "overdueInvoiceNextReminder",
    Date.now()
  );

  function isExcluded() {
    if (!ENVIRONMENT.PUSHER_EXCLUDED_USERS) {
      return false;
    } else {
      const excludedUsers = ENVIRONMENT.PUSHER_EXCLUDED_USERS.split(",");
      return user.email && excludedUsers.includes(user.email);
    }
  }

  const closeUpgradeModal = () => {
    setShowUpgradeModal(false);
    updateMapSettings("activeSearch", undefined);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setShowTrialEndingModal(showTrial(user));
    }, 3_600_000); // every hour
    setShowOverdueInvoiceModal(user.has_overdue_invoices && overdueInvoiceNextReminder <= Date.now());
    setShowMultiDeviceBlockModal(
      !!user._id && !!user._account._id && !!user.email && !isExcluded() && !showImpersonationBanner && !isMobile
    );
    setShowImpersonationBanner(!!cookies.impersonation);
    setShowOverdueInvoiceBanner(user.has_overdue_invoices && showOverdueInvoiceBanner);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Modals */}
      {showOverdueInvoiceModal && (
        <OverdueInvoiceModal closeModal={() => setOverdueInvoiceNextReminder(Date.now() + 12096e5)} />
      )}
      {showTrialEndingModal && <TrialEndingModal />}
      {showTopupModal && <TopupModal setShowTopupModal={setShowTopupModal} options={topupModalOptions} />}
      {showBillingAddressModal && (
        <BillingAddressModal {...billingAddressModalProps} onClose={() => setShowAddressModal(false, null)} />
      )}
      {showDebugModal && <DebugModal setDebugModal={setDebugModal} />}
      {showUserColorModal && <UserColorModal setUserColorModal={setUserColorModal} />}
      {showUpgradeModal && <UpgradeModal onClose={closeUpgradeModal} />}
      {addOnsStoreModalPath && <AddOnsStoreModal onClose={closeAddOnsStoreModal} initialPath={addOnsStoreModalPath} />}
      {showMultiDeviceBlockModal && <MultiDeviceBlockModal />}
      {user.licence_summary.includes("LT-GO-finder") && <LicenseBlockModal />}
      {/* Banners */}
      {showImpersonationBanner && <ImpersonationBanner />}
      {showOverdueInvoiceBanner && <OverdueInvoiceBanner onClose={() => setShowOverdueInvoiceBanner(false)} />}
      {newWorkspaceModal && !limitReached && (
        <NewWorkspaceModal source={newWorkspaceModal.source} onClose={closeNewWorkspaceModal} />
      )}
      {editWorkspaceModal && (
        <EditWorkspaceModal workspace={editWorkspaceModal.workspace} onClose={() => setEditWorkspaceModal(null)} />
      )}
    </>
  );
};
